/**
 * NIMUS CLOUD API Backend
 * NIMUS Cloud Backend Documentation
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface GatewayCodeResponseDto {
  /**
   * Generated code
   */
  gw_code: string;
  /**
   * Expiration time of newly generated code
   */
  code_expired_in: string;
}
